// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presentation-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.presentation-card-title {
  font-size: 2.5rem;
  margin-top: -400px;
  margin-bottom: 70px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  letter-spacing: 0.5ch;
  color: black;
  text-align: center;
}

.personnal-presentation-container {
  border-radius: 5px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.personnal-presentation-paragraph {
  border-left: 1px solid black;
  padding: 1em;
  margin-bottom: 15px;
  margin-top: 1em;
  text-align: justify;
}

.presentation-card-description {
  color: black;
  font-size: 22px;
  line-height: 2;
  font-family: Arial, sans-serif;
  padding: 20px;
  white-space: pre-line;
  opacity: 0;
  transition: opacity 1s ease-in-out;
  margin-top: 100px;
}

.presentation-card-description.fade-in {
  opacity: 1;
}

.presentation-card-image {
  width: 270px;
  height: 270px;
  border-radius: 30%;
  object-fit: cover;
  margin-right: 30px;
}

.personnal-presentation-text {
  margin: 5px 0;
  flex-wrap: wrap;
  font-size: 22px;
  color: rgb(0, 0, 0);
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.personnal-presentation-text-job {
  flex-wrap: wrap;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 22px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 20px;
}

.personnal-presentation-text:not(:last-child) {
  margin-bottom: 5px;
}

@media only screen and (max-width: 1300px) {
  .presentation-card-title {
    font-size: 30px;
    margin-top: 20px;
    margin-bottom: 60px;
    letter-spacing: 0.5ch;
  }
  .personnal-presentation-paragraph {
    padding: 1em;
    margin-bottom: 15px;
  }
  .presentation-card-image {
    width: 220px;
    height: 220px;
  }
  
  .presentation-card-description {
    font-size: 18px;
    line-height: 2;
    padding: 20px;
    opacity: 0;
    margin-top: 60px;
  }
  .personnal-presentation-text {
    margin: 5px 0;
    font-size: 18px;
  }
  
  .personnal-presentation-text-job {
    font-size: 18px;
  }
}

@media only screen and (min-width: 751px) {
  .presentation-card {
    flex-direction: column;
    align-items: center;
  }

  .presentation-card-image {
    margin-bottom: 20px;
  }

  .personnal-presentation-container {
    flex-direction: row;
    align-items: flex-start;
  }

  .personnal-presentation-paragraph {
    margin-top: 0px;
    margin-bottom: 15px;
    text-align: justify;
  }
}

@media only screen and (max-width: 750px) {
  .presentation-card {
    flex-direction: column;
    align-items: center;
    transform: translateY(-400px);
    margin-bottom: 0px;
    margin-top: 350px;
  }
  
  .presentation-card-title {
    font-size: 20px;
    margin-top: 100px;
    margin-bottom: 20px;
    letter-spacing: 0.1ch;
  }
  
  .presentation-card-image {
    width: 60%;
    height: auto;
    margin-right: 0;
    margin-bottom: 20px;
  }
  
  .personnal-presentation-container {
    padding: 10px;
    text-align: center;
    align-items: center;
  }

  .personnal-presentation-paragraph {
    margin-bottom: 100px;
    padding: 0.5em;
    text-align: justify;
    border-left: none;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
  }
  
  .presentation-card-description {
    font-size: 15px;
    line-height: 1.7;
    letter-spacing: 0.5px;
    padding: 20px;
    opacity: 0;
    font-size: 12px;
    margin-top: 0px;
    margin-bottom: -500px;
  }
  
  .personnal-presentation-text {
    margin: 5px 0;
    font-size: 13px;
    font-weight: normal;
  }
  
  .personnal-presentation-text-job {
    font-size: 13px;
    font-weight: bold;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/Cards/cards-css/presentation.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gDAAgD;EAChD,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;EACrB,UAAU;EACV,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gDAAgD;EAChD,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,UAAU;IACV,eAAe;IACf,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".presentation-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.presentation-card-title {\n  font-size: 2.5rem;\n  margin-top: -400px;\n  margin-bottom: 70px;\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n  letter-spacing: 0.5ch;\n  color: black;\n  text-align: center;\n}\n\n.personnal-presentation-container {\n  border-radius: 5px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.personnal-presentation-paragraph {\n  border-left: 1px solid black;\n  padding: 1em;\n  margin-bottom: 15px;\n  margin-top: 1em;\n  text-align: justify;\n}\n\n.presentation-card-description {\n  color: black;\n  font-size: 22px;\n  line-height: 2;\n  font-family: Arial, sans-serif;\n  padding: 20px;\n  white-space: pre-line;\n  opacity: 0;\n  transition: opacity 1s ease-in-out;\n  margin-top: 100px;\n}\n\n.presentation-card-description.fade-in {\n  opacity: 1;\n}\n\n.presentation-card-image {\n  width: 270px;\n  height: 270px;\n  border-radius: 30%;\n  object-fit: cover;\n  margin-right: 30px;\n}\n\n.personnal-presentation-text {\n  margin: 5px 0;\n  flex-wrap: wrap;\n  font-size: 22px;\n  color: rgb(0, 0, 0);\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n}\n\n.personnal-presentation-text-job {\n  flex-wrap: wrap;\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n  font-size: 22px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 20px;\n}\n\n.personnal-presentation-text:not(:last-child) {\n  margin-bottom: 5px;\n}\n\n@media only screen and (max-width: 1300px) {\n  .presentation-card-title {\n    font-size: 30px;\n    margin-top: 20px;\n    margin-bottom: 60px;\n    letter-spacing: 0.5ch;\n  }\n  .personnal-presentation-paragraph {\n    padding: 1em;\n    margin-bottom: 15px;\n  }\n  .presentation-card-image {\n    width: 220px;\n    height: 220px;\n  }\n  \n  .presentation-card-description {\n    font-size: 18px;\n    line-height: 2;\n    padding: 20px;\n    opacity: 0;\n    margin-top: 60px;\n  }\n  .personnal-presentation-text {\n    margin: 5px 0;\n    font-size: 18px;\n  }\n  \n  .personnal-presentation-text-job {\n    font-size: 18px;\n  }\n}\n\n@media only screen and (min-width: 751px) {\n  .presentation-card {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .presentation-card-image {\n    margin-bottom: 20px;\n  }\n\n  .personnal-presentation-container {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n\n  .personnal-presentation-paragraph {\n    margin-top: 0px;\n    margin-bottom: 15px;\n    text-align: justify;\n  }\n}\n\n@media only screen and (max-width: 750px) {\n  .presentation-card {\n    flex-direction: column;\n    align-items: center;\n    transform: translateY(-400px);\n    margin-bottom: 0px;\n    margin-top: 350px;\n  }\n  \n  .presentation-card-title {\n    font-size: 20px;\n    margin-top: 100px;\n    margin-bottom: 20px;\n    letter-spacing: 0.1ch;\n  }\n  \n  .presentation-card-image {\n    width: 60%;\n    height: auto;\n    margin-right: 0;\n    margin-bottom: 20px;\n  }\n  \n  .personnal-presentation-container {\n    padding: 10px;\n    text-align: center;\n    align-items: center;\n  }\n\n  .personnal-presentation-paragraph {\n    margin-bottom: 100px;\n    padding: 0.5em;\n    text-align: justify;\n    border-left: none;\n    border-top: 1px solid black;\n    border-bottom: 1px solid black;\n  }\n  \n  .presentation-card-description {\n    font-size: 15px;\n    line-height: 1.7;\n    letter-spacing: 0.5px;\n    padding: 20px;\n    opacity: 0;\n    font-size: 12px;\n    margin-top: 0px;\n    margin-bottom: -500px;\n  }\n  \n  .personnal-presentation-text {\n    margin: 5px 0;\n    font-size: 13px;\n    font-weight: normal;\n  }\n  \n  .personnal-presentation-text-job {\n    font-size: 13px;\n    font-weight: bold;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
